import { Item, ItemType } from '@inno-sdks/files'
import { AppId } from '@inno-tools/container-bridge'
import { DEFAULT_SHORTCUT_ITEM_SIZE } from 'modules/desktop/constants'

import type { SystemShortcutConfig } from './systemShortcut.types'

export const MY_BILLS_PATH = '/system-actions/accounting/invoices'

export const MY_BILLS_SHORTCUT = {
  key: 'my-bills',
  name: 'My Bills',
  shortcutUrl: `${process.env.REACT_APP_DOMAIN}${MY_BILLS_PATH}`,
  displayNameKey: 'my_bills',
  iconAppId: AppId.ACCOUNTING,
  action: 'openMyBills',
  presentation: {
    itemType: 'shortcut',
    label: 'My Bills',
    iconType: 'image',
    icon: '/app-icons/accounting.webp',
    isPinned: false,
    isPermanent: true,
    position: { row: 0, col: 0 },
    size: DEFAULT_SHORTCUT_ITEM_SIZE,
    onClick: {
      type: 'openUrl',
      url: `${process.env.REACT_APP_DOMAIN}${MY_BILLS_PATH}`
    }
  }
} satisfies SystemShortcutConfig

/** Ignores origin so matching survives a different REACT_APP_DOMAIN per environment. */
const normalizePath = (value: string): string => {
  try {
    return new URL(value, window.location.origin).pathname
  } catch {
    return value
  }
}

/** Identifies the provisioned My Bills shortcut without relying on its file id. */
export const isMyBillsShortcut = (item: Item): boolean =>
  item.type === ItemType.Shortcut &&
  item.name === MY_BILLS_SHORTCUT.name &&
  item.extra?.isPermanent === true &&
  normalizePath(item.metaData.shortcutUrl) === MY_BILLS_PATH
